<template>
  <div>
    <div
      v-if="!totemMode.isActive"
      class="text-center pa-5"
    >
      Modo totem desactivado
    </div>
    <div v-else>
      <v-sheet
        :color="totemMode.data.content.bg_color"
        class="d-flex align-center justify-center flex-column h-100"
      >
        <section v-if="isLoading" class="pa-5" style="width: 300px;">
          <Loading :message="$t('magicLink.loading')" />
        </section>
        <section v-else-if="mediaAccess && (mediaAccess.video === false || mediaAccess.audio === false)" class="pa-5 text-center">
          <div class="icon mb-4">
            <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 10.5V7M12 14H12.01M9.9 19.2L11.36 21.1467C11.5771 21.4362 11.6857 21.5809 11.8188 21.6327C11.9353 21.678 12.0647 21.678 12.1812 21.6327C12.3143 21.5809 12.4229 21.4362 12.64 21.1467L14.1 19.2C14.3931 18.8091 14.5397 18.6137 14.7185 18.4645C14.9569 18.2656 15.2383 18.1248 15.5405 18.0535C15.7671 18 16.0114 18 16.5 18C17.8978 18 18.5967 18 19.1481 17.7716C19.8831 17.4672 20.4672 16.8831 20.7716 16.1481C21 15.5967 21 14.8978 21 13.5V7.8C21 6.11984 21 5.27976 20.673 4.63803C20.3854 4.07354 19.9265 3.6146 19.362 3.32698C18.7202 3 17.8802 3 16.2 3H7.8C6.11984 3 5.27976 3 4.63803 3.32698C4.07354 3.6146 3.6146 4.07354 3.32698 4.63803C3 5.27976 3 6.11984 3 7.8V13.5C3 14.8978 3 15.5967 3.22836 16.1481C3.53284 16.8831 4.11687 17.4672 4.85195 17.7716C5.40326 18 6.10218 18 7.5 18C7.98858 18 8.23287 18 8.45951 18.0535C8.76169 18.1248 9.04312 18.2656 9.2815 18.4645C9.46028 18.6137 9.60685 18.8091 9.9 19.2Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </div>
          <h2 style="font-weight: 400; font-size: 20px;" class="mb-4">
            <strong>Error en Llamada.</strong><br /><br />
            {{ mediaAccess.errorMessage }}. <br /><br />
            Por favor obtenga otro número de atención o diríjase al mesón de atención presencial
          </h2>
          <v-btn
            color="primary"
            @click="$widget.reTry()"
            elevetaion="0"
            :style="{
              boxShadow: 'none',
              borderRadius: '12px',
            }"
          >
            Reintentar
          </v-btn>
        </section>
        <div v-else class="px-10 text-center" style="max-width: 600px">
          <v-img
            class="brand"
            :src="totemMode.data.content.brand_src"
            aspect-ratio="1"
            width="250"
            style="border-radius: 50%; margin: 0 auto;"
          ></v-img>

          <h2
            class="mb-3 mt-2"
            :style="`color: ${totemMode.data.content.text_color}`"
          >
            {{ totemMode.data.content.title }}
          </h2>

          <h4
            class="font-weight-regular text-muted mb-3"
            :style="`color: ${totemMode.data.content.text_color}`"
          >
            {{ totemMode.data.content.description }}
          </h4>
        </div>
      </v-sheet>
      <WaitingDialog v-if="onHoldContent" :content="onHoldContent" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { Component, Vue } from 'vue-property-decorator'
import TotemService from '@/services/Totem'
import { mapActions } from 'vuex'

@Component({
  components: {
    OcularSign: () => import(/* webpackPrefetch: true */ '@/components/OcularSign.vue'),
    WaitingDialog: () => import('@/views/totem/components/WaitingDialog.vue'),
    Loading: () => import(/* webpackPrefetch: true */ '@/components/Loading.vue')
  },
  data () {
    return {
      isLoading: false,
      retryTimer: null
    }
  },
  computed: {
    widget () {
      return this.$store.state.widget
    },
    state () {
      return this.$store.state.storage.state
    },
    totemMode () {
      return this.$organization.totemMode()
    },
    onHoldContent () {
      return this.totemMode?.data?.on_hold_content ?? null
    },
    mediaAccess () {
      return this.$store.state.mediaAccess
    }
  },
  methods: {
    ...mapActions({
      setTotemWaitingDialogShow: 'setTotemWaitingDialogShow',
      setMediaAccess: 'setMediaAccess'
    })
  }
})
export default class Totem extends Vue {
  beforeCreate () {
    this.$storage.setState(1)
  }

  startAvailabilityRetry () {
    if (this.retryTimer) return
    this.retryTimer = setInterval(() => {
      if (!this.mediaAccess?.audio || !this.mediaAccess?.video) {
        this.stopAvailabilityRetry()
        return
      }

      this.$signalSocketEvents.updateDeviceState('available')
    }, 30000)
  }

  stopAvailabilityRetry () {
    if (this.retryTimer) {
      clearInterval(this.retryTimer)
      this.retryTimer = null
    }
  }

  async updateTotemState () {
    const code = this.widget.code
    const available = (this.state.id === 1)

    if (code && available) {
      const params = {
        totemId: code,
        status: 'available'
      }

      await TotemService.setTotemStatus(params)
    }
  }

  async mounted () {
    this.isLoading = true;

    const mediaAccess = await this.$mediaDevices.checkMediaAccess();
    this.setMediaAccess(mediaAccess);

    this.isLoading = false;

    await this.$socketEvents.connectListen()
    this.$socketEvents.updateDeviceMetadata({
      mediaAccess: this.mediaAccess
    })

    if (this.mediaAccess.video === false || this.mediaAccess.audio === false) {
      this.$socketEvents.updateDeviceState('unavailable')
      this.$socketEvents.leaveTotemRoom()
      return false
    }

    this.$socketEvents.updateDeviceState('available')
    this.$socketEvents.joinTotemRoom()
    await this.updateTotemState()

    this.$listenSocket.on('waiting_for_call', () => {
      this.setTotemWaitingDialogShow(true)
    })

    this.$signalSocket.on('waiting_for_call', () => {
      this.setTotemWaitingDialogShow(true)
    })

    // ON PREMISE SIGNAL SOCKET
    await this.$signalSocketEvents.connectListen()
    const setAvailable = this.$route.query.setAvailable
    if (setAvailable && (setAvailable === 'true' || setAvailable === true)) {
      this.$signalSocketEvents.updateDeviceState('available')
    }

    this.startAvailabilityRetry()
  }

  beforeDestroy() {
    this.$listenSocket.off('waiting_for_call')
    this.$signalSocket.off('waiting_for_call')
    this.setTotemWaitingDialogShow(false)
    this.stopAvailabilityRetry()
  }
}
</script>

<style>
.h-100 {
  height: 100vh;
}

.icon {
  width: 80px;
  height: 80px;
  border: 1px solid #c4c4c4;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto;
}

.icon svg {
  width: 40px;
  height: 40px;
  color: #ff4c00;
}
</style>